import styled from 'styled-components';
import {
  colorWhite2,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from 'styles';

export const Wrapper = styled.section`
  width: 100%;
  padding: 16px;
  margin-top: 16px;
  background: #ffffff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.16);
  border-radius: 2px;

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 24px;
  }
  & > div h1 {
    margin-bottom: 8px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    & > div h1 {
      margin-bottom: 0;
    }
  }
`;

export const Comments = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  margin-left: -4px;
  overflow: hidden;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-top: 20px;
    overflow: hidden;
  }
`;

export const Comment = styled.img`
  display: block;
  width: 48px;
  height: 48px;
  background: green;
  border: 4px solid #ffffff;
  border-radius: 50%;
  box-sizing: initial;
  margin-left: -15px;

  &:first-child {
    margin-left: 0;
  }
`;

export const CommentsLink = styled.a`
  display: inline-block;
  color: ${colorWhite2};
  margin-top: 12px;
  padding: 12px 16px;
  font-family: ${fontFamilySecondary};
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  border: 1px solid #cbdaf4;
  border-radius: 2px;
  width: 100%;
  text-align: center;

  &:hover {
    opacity: 0.8;
  }

  & > svg {
    margin-top: -4px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    width: unset;
    margin-top: 20px;
  }
`;
